import { ComplexEnum } from '../../utils/complexEnum'
import {
  Friday,
  Monday,
  Saturday,
  Sunday,
  Thursday,
  Tuesday,
  Wednesday,
} from './instances'

export type DailyItem =
  | typeof Monday
  | typeof Tuesday
  | typeof Wednesday
  | typeof Thursday
  | typeof Friday
  | typeof Saturday
  | typeof Sunday

class DailyItemEnum extends ComplexEnum<
  'DailyItem',
  DailyItem,
  DailyItem['id']
> {
  readonly typename = 'DailyItem'
  readonly Monday = Monday
  readonly Tuesday = Tuesday
  readonly Wednesday = Wednesday
  readonly Thursday = Thursday
  readonly Friday = Friday
  readonly Saturday = Saturday
  readonly Sunday = Sunday

  get values() {
    return [
      this.Monday,
      this.Tuesday,
      this.Wednesday,
      this.Thursday,
      this.Friday,
      this.Saturday,
      this.Sunday,
    ]
  }

  fromValue = (value: number) =>
    this.find(({ value: _value }) => value === _value)
}

export const DailyItem = new DailyItemEnum()
